import {
  Avatar,
  Box,
  Card,
  CardBody,
  CardHeader,
  HStack,
  SkeletonCircle,
  SkeletonText,
  StackProps,
  Text,
} from '@chakra-ui/react';

type Props = StackProps & {
  isLoading?: boolean;
  icon?: React.ReactElement;
  label: string;
  title: string;
  value: string;
};

export default function MetricCard({
  isLoading,
  title,
  label,
  value,
  icon,
  ...props
}: Props) {
  return (
    <Card variant="stat" size="sm">
      <CardHeader>
        {isLoading && (
          <SkeletonText isLoaded={!isLoading} noOfLines={1} w="80%" />
        )}
        {!isLoading && title}
      </CardHeader>
      <CardBody>
        {isLoading && (
          <HStack spacing="30px" w="full" alignItems="center">
            <SkeletonCircle isLoaded={!isLoading} boxSize="60px" />
            <SkeletonText isLoaded={!isLoading} noOfLines={2} flex={1} />
          </HStack>
        )}
        {!isLoading && (
          <HStack
            spacing="16px"
            alignItems="center"
            justifyContent="space-between"
            {...props}
          >
            <Avatar
              bgColor="white"
              borderColor="#E2E4E9"
              borderWidth="1px"
              icon={icon}
              size="lg"
            />
            <Box textAlign="right">
              <Text
                as="span"
                color="#0a0d14cc"
                letterSpacing="-0.176px"
                lineHeight="100%"
                fontSize="30px"
                fontWeight="700"
              >
                {value}
              </Text>
              <br />
              <Text
                as="strong"
                color="#868C98"
                letterSpacing="0.22px"
                textTransform="uppercase"
                fontWeight="500"
                fontSize="11px"
                lineHeight="100%"
              >
                {label}
              </Text>
            </Box>
          </HStack>
        )}
      </CardBody>
    </Card>
  );
}
